<div class="add-katalog__button">
  <button mat-flat-button class="add-katalog-btn" (click)="openMenu()">
    <mat-icon>add</mat-icon>
    {{ 'catalogues.button.addCatalog' | translate }}
  </button>
</div>

<div (click)="closeMenu()" [class.open]="isPopupOpen" class="add-katalog">
  <div (click)="$event.stopPropagation()" class="add-katalog__content">
    <mat-form-field>
      <mat-label>
        {{ 'catalogues.priceGroup' | translate }}
      </mat-label>
      <input
        matInput
        [(ngModel)]="katalogForm.preisgruppe"
        placeholder="Preisgruppe"
        type="number"
      />

    </mat-form-field>
    <mat-form-field>
      <mat-label>
        {{ 'catalogues.RVSEversion' | translate }}
      </mat-label>
      <input
        matInput
        [(ngModel)]="katalogForm.rvseVersion"
        placeholder="RVSE Version"
        type="number"
      />

    </mat-form-field>
    <mat-form-field>
      <mat-label>
        {{ 'catalogues.shorthandSymbol' | translate }}
      </mat-label>
      <input
        matInput
        [(ngModel)]="katalogForm.kuerzel"
        placeholder="Kürzel"
        type="text"
        [maxlength]="LIMITS.SHORT_LABEL"
      />

    </mat-form-field>
    <mat-form-field>
      <mat-label>
        {{ 'catalogues.roleDesignation' | translate }}
      </mat-label>
      <input
        matInput
        [(ngModel)]="katalogForm.rollenbezeichnung"
        placeholder="Rollenbezeichnung"
        type="text"
        [maxlength]="LIMITS.SHORT_LABEL"
      />

    </mat-form-field>
    <div class="add-katalog__button-group">
      <button mat-raised-button class="secondary-btn" (click)="closeMenu()">{{ 'general.cancel' | translate }}</button>
      <button mat-flat-button (click)="addKatalog()">{{ 'catalogues.button.createCatalog' | translate }}</button>
    </div>
  </div>
</div>

<div class='catalogues__table-wrapper'>
  <table mat-table [dataSource]='kataloge' class='catalogues__table'>
    <ng-container matColumnDef='RVSE'>
      <th mat-header-cell *matHeaderCellDef>{{ 'catalogues.RVSEversion' | translate }}</th>
      <td mat-cell *matCellDef='let katalog'>RVSE{{ katalog.rvseVersion }}</td>
    </ng-container>
    <ng-container matColumnDef='PG'>
      <th mat-header-cell *matHeaderCellDef>{{ 'catalogues.priceGroup' | translate }}</th>
      <td mat-cell *matCellDef='let katalog'>PG{{ katalog.preisgruppe }}</td>
    </ng-container>
    <ng-container matColumnDef='shortHandSymbol'>
      <th mat-header-cell *matHeaderCellDef>{{ 'catalogues.shorthandSymbol' | translate }}</th>
      <td mat-cell *matCellDef='let katalog'>{{ katalog.rollenbezeichnung }}</td>
    </ng-container>
    <ng-container matColumnDef='role'>
      <th mat-header-cell *matHeaderCellDef>{{ 'catalogues.roleDesignation' | translate }}</th>
      <td mat-cell *matCellDef='let katalog'>{{ katalog.bezeichnung }}</td>
    </ng-container>
    <ng-container matColumnDef='edit'>
      <th mat-header-cell *matHeaderCellDef>{{ 'general.edit' | translate }}</th>
      <td mat-cell *matCellDef='let katalog'>
        <button mat-raised-button [routerLink]="['/katalog', katalog.id]">
          <mat-icon>edit</mat-icon>
          {{ 'catalogues.button.editTasksAndKnowledge' | translate }}
        </button>
      </td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      *matRowDef="let _row; columns: displayedColumns"
    ></tr>
  </table>
</div>
